export const LANG_KH_NAME = 'kh';

export const LANG_KH_TRANS = { 
    'Report & Analysis': 'របាយការណ៍និងវិភាគ',
    'Profile': 'ទម្រង់',
    'EFFICIENCY': 'ប្រសិទ្ធភាព',
    'Customer' : 'អតិថិជន'
};